export enum OverlayTypes {
  MODAL,
  CONFIRMATION,
  DRAWER,
}
